import { render, staticRenderFns } from "./App.vue?vue&type=template&id=48e1cefc&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./App.vue?vue&type=style&index=0&id=48e1cefc&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "48e1cefc",
  "02a76864"
  
)

export default component.exports